import { useContext, useCallback, useMemo } from 'react';

import { CREATE_PAGE_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName.ts';
import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';
import { SPACE_CALENDAR } from '@confluence/named-routes/entry-points/routes.ts';

import type { Creatable, CanHandle, Handle } from '../createContentFromTemplateTypes.ts';

import { useNavigation } from './useNavigation.ts';

export const useCalendarCreatable = (): Creatable => {
	const experienceTracker = useContext(ExperienceTrackerContext);
	const navigate = useNavigation();

	const canHandle: CanHandle = useCallback(
		(template) =>
			template.itemModuleCompleteKey ===
			'com.atlassian.confluence.extra.team-calendars:tc-on-space-blueprint-webitem',
		[],
	);

	const handle: Handle = useCallback(
		async (_, spaceKey, options = {}) => {
			const { openContentInNewTab } = options;

			navigate(SPACE_CALENDAR.toUrl({ spaceKey }), {
				openContentInNewTab,
			});

			experienceTracker.succeed({ name: CREATE_PAGE_EXPERIENCE });
			return true;
		},
		[experienceTracker, navigate],
	);

	return useMemo(() => ({ canHandle, handle }), [canHandle, handle]);
};
